import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FolderX, ArrowLeft, Mail } from 'lucide-react';
import Button from '../components/Button';
import { usePageTitle } from '../hooks/usePageTitle';

interface LocationState {
  workspaceName?: string;
  message?: string;
}

const WorkspaceUnavailablePage: React.FC = () => {
  usePageTitle('Workspace Unavailable', 'This workspace is no longer available');
  
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState | undefined;

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-error-100 dark:bg-error-900/30">
            <FolderX className="w-10 h-10 text-error-600 dark:text-error-400" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-text-primary dark:text-text-dark-primary mb-3">
          Workspace Unavailable
        </h1>

        {/* Message */}
        <p className="text-text-secondary dark:text-text-dark-secondary mb-6">
          {state?.message || 'This workspace is no longer available. It may have been deleted or deactivated by the workspace owner.'}
        </p>

        {/* Workspace name if available */}
        {state?.workspaceName && (
          <div className="mb-6 p-4 bg-white dark:bg-background-dark-secondary rounded-lg">
            <p className="text-sm text-text-tertiary dark:text-text-dark-tertiary mb-1">
              Requested workspace:
            </p>
            <p className="font-medium text-text-primary dark:text-text-dark-primary">
              {state.workspaceName}
            </p>
          </div>
        )}

        {/* Help text */}
        <div className="mb-8 p-4 border border-border-light dark:border-border-dark rounded-lg bg-white dark:bg-background-dark-secondary">
          <div className="flex items-start gap-3">
            <Mail className="w-5 h-5 text-text-tertiary dark:text-text-dark-tertiary flex-shrink-0 mt-0.5" />
            <div className="text-left">
              <p className="text-sm font-medium text-text-primary dark:text-text-dark-primary mb-1">
                Need access?
              </p>
              <p className="text-sm text-text-secondary dark:text-text-dark-secondary">
                Contact your workspace owner or organization administrator for more information about this workspace.
              </p>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="secondary"
            size="md"
            icon={ArrowLeft}
            onClick={() => navigate(-1)}
          >
            Go back
          </Button>
          <Button
            variant="primary"
            size="md"
            onClick={() => navigate('/workspaces')}
          >
            View My Workspaces
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceUnavailablePage;










